import { useState } from "react";
import { createUseStyles } from "react-jss";
import RedButton from "../refresh/RedButton";
import SidebarItem from "../refresh/SidebarItem";
import SidebarLightbox from "../refresh/SidebarLightbox";
import styles from "./types/sharedStyles";

const useStyles = createUseStyles({
  ...styles,
  message: {
    margin: 0,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
});

const Content = ({ content, next }) => {
  const classes = useStyles();

  switch (content) {
    case "media":
      return (
        <div className={classes.info}>
          <video
            key="media"
            className={classes.showcase}
            autoPlay
            muted
            loop
            preload="metadata"
          >
            <source
              src={`${window.location.origin}/assets/videos/tip-richnote.mp4`}
              type="video/mp4"
            />
          </video>
          <h1>Media Popup</h1>
          <p>
            The Media Popup is the perfect way to convey information to your
            tour's user. You can add text, or audio and video from the CMS. You
            can also embed content (including videos) from external sites - the
            possibilities are endless!
          </p>
          <p>
            If you want a different icon to represent your popup in the tour, we
            have you covered. Select from our library of assets, or upload your
            own.
          </p>
          <RedButton onClick={next("media")}>Next</RedButton>
        </div>
      );
    case "web":
      return (
        <div className={classes.info}>
          <video
            key="web"
            className={classes.showcase}
            autoPlay
            muted
            loop
            preload="metadata"
          >
            <source
              src={`${window.location.origin}/assets/videos/tip-link-lightbox.mp4`}
              type="video/mp4"
            />
          </video>
          <h1>External Link</h1>
          <p>
            Link to another site, either as a lightbox or as a direct link that
            opens in a new tab.
          </p>
          <RedButton onClick={next("web")}>Next</RedButton>
        </div>
      );

    case "audio":
      return (
        <div className={classes.info}>
          <video
            key="audio"
            className={classes.showcase}
            autoPlay
            muted
            loop
            preload="metadata"
          >
            <source
              src={`${window.location.origin}/assets/videos/tip-audio.mp4`}
              type="video/mp4"
            />
          </video>
          <h1>Audio</h1>
          <p>Trigger an audio clip from the CMS</p>
          <RedButton onClick={next("audio")}>Next</RedButton>
        </div>
      );
    case "link":
      return (
        <div className={classes.info}>
          <video
            key="link"
            className={classes.showcase}
            autoPlay
            muted
            loop
            preload="metadata"
          >
            <source
              src={`${window.location.origin}/assets/videos/tip-movement.mp4`}
              type="video/mp4"
            />
          </video>
          <h1>Link Node</h1>
          <p>
            A link node is the perfect way to connect two scenes together.
            Simply choose the scene you want to connect to, and then you'll be
            able to smoothly transition to it.
          </p>
          <p>
            You can also choose to enable Boomerang mode, which means a
            corresponding node on the other scene will return you to this image,
            allowing you to make a two way connection between images.
          </p>
          <RedButton onClick={next("link")}>Next</RedButton>
        </div>
      );
    case "fade":
      return (
        <div className={classes.info}>
          <video
            key="fade"
            className={classes.showcase}
            autoPlay
            muted
            loop
            preload="metadata"
          >
            <source
              src={`${window.location.origin}/assets/videos/tip-crossfade.mp4`}
              type="video/mp4"
            />
          </video>
          <h1>Fade Node</h1>
          <p>
            Crossfade between two images. Can be helpful if two images are in
            the same location - i.e. with a door open or closed
          </p>
          <RedButton onClick={next("fade")}>Next</RedButton>
        </div>
      );
    case "elevate-up":
      return (
        <div className={classes.info}>
          <video
            key="elevate"
            className={classes.showcase}
            autoPlay
            muted
            loop
            preload="metadata"
          >
            <source
              src={`${window.location.origin}/assets/videos/tip-elevator.mp4`}
              type="video/mp4"
            />
          </video>
          <h1>Transition Up</h1>
          <p>Link to something above you. Good for going up stairs or lifts.</p>
          <RedButton onClick={next("elevate-up")}>Next</RedButton>
        </div>
      );
    case "elevate-down":
      return (
        <div className={classes.info}>
          <video
            key="elevate"
            className={classes.showcase}
            autoPlay
            muted
            loop
            preload="metadata"
          >
            <source
              src={`${window.location.origin}/assets/videos/tip-elevator.mp4`}
              type="video/mp4"
            />
          </video>
          <h1>Transition Down</h1>
          <p>
            Like transition up, except it takes you down. Useful for conveying
            movement down a staircase or a lift.
          </p>
          <RedButton onClick={next("elevate-down")}>Next</RedButton>
        </div>
      );
    case "poi":
      return (
        <div className={classes.info}>
          <video
            key="poi"
            className={classes.showcase}
            autoPlay
            muted
            loop
            preload="metadata"
          >
            <source
              src={`${window.location.origin}/assets/videos/tip-lookat.mp4`}
              type="video/mp4"
            />
          </video>
          <h1>Look At</h1>
          <p>
            Got something in your scene you want to draw attention to, but you
            seem to always point the wrong way? The Look At node allows you to
            point the user towards a location in a scene when they enter the
            image to ensure they always get the best angle.
          </p>
          <RedButton onClick={next("poi")}>Next</RedButton>
        </div>
      );
    case "gallery":
      return (
        <div className={classes.info}>
          <video
            key="gallery"
            className={classes.showcase}
            autoPlay
            muted
            loop
            preload="metadata"
          >
            <source
              src={`${window.location.origin}/assets/videos/tip-gallery.mp4`}
              type="video/mp4"
            />
          </video>
          <h1>Gallery</h1>
          <p>
            Embed a Gallery from the CMS. To use, first create a gallery in the
            CMS, then create one of these nodes - you can then select from the
            galleries associated with this tour.
          </p>
          <RedButton onClick={next("gallery")}>Next</RedButton>
        </div>
      );
    case "timeline":
      return (
        <div className={classes.info}>
          <video
            key="timeline"
            className={classes.showcase}
            autoPlay
            muted
            loop
            preload="metadata"
          >
            <source
              src={`${window.location.origin}/assets/videos/tip-timeline.mp4`}
              type="video/mp4"
            />
          </video>
          <h1>Timeline</h1>
          <p>
            Link to multiple scenes. Perfect for showing the progression of a
            location over time. Note: this has been somewhat superceeded by the
            Timeline feature (see settings), but still can be useful if you want
            to do so in a node.
          </p>
          <RedButton onClick={next("timeline")}>Next</RedButton>
        </div>
      );
    case "sticker":
      return (
        <div className={classes.info}>
          <video
            key="audio"
            className={classes.showcase}
            autoPlay
            muted
            loop
            preload="metadata"
          >
            <source
              src={`${window.location.origin}/assets/videos/tip-sticker.mp4`}
              type="video/mp4"
            />
          </video>
          <h1>Sticker</h1>
          <p>
            Stickers are larger graphics that appear directly on your tour without
            opening a popup. Perfect for displaying logos, labels, or decorative
            elements. You can choose from preset sizes and customize the icon.
          </p>
          <p>
            Stickers have no hover effects, making them ideal for static graphics
            that should remain visible and consistent.
          </p>
          <RedButton onClick={next("sticker")}>Next</RedButton>
        </div>
      );
    default:
      return (
        <p className={classes.message}>Select a hotspot type to get started</p>
      );
  }
};

export const image = name =>
  `${window.location.origin}/assets/hotspots/${name}.png`;

const CreateHotspot = ({
  show,
  onSelect,
  switchToLegacy = null,
  onClose,
  template = false,
}) => {
  const classes = useStyles();
  const [selected, setSelected] = useState(template ? "media" : "link");

  const select = choice =>
    choice === selected ? onSelect(choice) : setSelected(choice);

  return (
    <SidebarLightbox
      show={show}
      onClose={onClose}
      sidebar={
        <>
          <h1 className={classes.title}>
            New {template ? "Template" : "Hotspot"}
          </h1>
          <p className={classes.subtitle}>
            Select the type of {template ? "template" : "hotspot"} you want to
            place
          </p>
          {!template && (
            <>
              <SidebarItem
                selected={selected === "link"}
                onClick={() => select("link")}
                image={image`direction`}
                title="Movement"
                subtitle="Move between images"
              />
              <SidebarItem
                selected={selected === "fade"}
                onClick={() => select("fade")}
                image={image`crossfade`}
                title="Crossfade"
                subtitle="Fade to another image"
              />
              <SidebarItem
                selected={selected === "elevate-up"}
                onClick={() => select("elevate-up")}
                image={image`elevate-up`}
                title="Transition Up"
                subtitle="Link to something above"
              />
              <SidebarItem
                selected={selected === "elevate-down"}
                onClick={() => select("elevate-down")}
                image={image`elevate-down`}
                title="Transition Down"
                subtitle="Link to something below"
              />
              <hr />
            </>
          )}
          <SidebarItem
            selected={selected === "media"}
            onClick={() => select("media")}
            image={image`info-plus`}
            title="Media Popup"
            subtitle="Text, images - whatever!"
          />
          <SidebarItem
            selected={selected === "web"}
            onClick={() => select("web")}
            image={image`web-link`}
            title="External Link"
            subtitle="Hyperlink to another site"
          />
          <SidebarItem
            selected={selected === "gallery"}
            onClick={() => select("gallery")}
            image={image`gallery`}
            title="Gallery"
            subtitle="Show a gallery"
          />
          <SidebarItem
            selected={selected === "audio"}
            onClick={() => select("audio")}
            image={image`audio`}
            title="Audio"
            subtitle="Trigger an audio clip"
          />
          <SidebarItem
            selected={selected === "sticker"}
            onClick={() => select("sticker")}
            image={image`star-circle`}
            title="Sticker"
            subtitle="Large static graphics"
          />
          {!template && (
            <>
              <SidebarItem
                selected={selected === "poi"}
                onClick={() => select("poi")}
                image={image`poi`}
                title="Look At"
                subtitle="Highlight a location"
              />
              <SidebarItem
                selected={selected === "timeline"}
                onClick={() => select("timeline")}
                image={image`timeline`}
                title="Timeline"
                subtitle="Link to multiple scenes"
              />
            </>
          )}
          <div className={classes.grow} />
          {!template && switchToLegacy && (
            <p
              className={classes.legacy}
              onClick={switchToLegacy}
              role="button"
            >
              Switch to legacy hotspots
            </p>
          )}
        </>
      }
    >
      <Content content={selected} next={type => () => onSelect(type)} />
    </SidebarLightbox>
  );
};

export default CreateHotspot;
